module.exports = __webpack_public_path__ + "static/media/multiple-select-tool-white.a51f96ed.svg";